<template>
  <v-list-tile class="default-font">
    <v-list-tile-content>
      <v-list-tile-title>
        <slot></slot>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="subtitle" class="caption text-black">
        {{ subtitle }}
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>
<style scoped>
.default-font {
  font-size: 14px !important;
}
.v-list__tile > * {
  padding: 2px !important;
  font-size: 14px !important;
}
</style>
<script>
export default {
  name: 'ListTile',
  props: {
    subtitle: {
      type: String,
      default: null,
    },
  },
};
</script>
